/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type BuyerChatRespLazy_viewer = {
    readonly " $fragmentRefs": FragmentRefs<"BuyerChatResp_viewer">;
    readonly " $refType": "BuyerChatRespLazy_viewer";
};
export type BuyerChatRespLazy_viewer$data = BuyerChatRespLazy_viewer;
export type BuyerChatRespLazy_viewer$key = {
    readonly " $data"?: BuyerChatRespLazy_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"BuyerChatRespLazy_viewer">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BuyerChatRespLazy_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "BuyerChatResp_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
(node as any).hash = '519efc28a9dceb4e3f708a8fdc40fedb';
export default node;
